<template>
  <el-dialog
    title=""
    v-model="visible"
    width="540px"
    custom-class="teacher-dialog"
    @close="handleClose"
  >
    <div class="teacher-detail">
      <div class="teacher-base">
        <div class="img-wrapper">
          <img :src="teacherData.file_url" alt="" />
        </div>
        <div class="teacher-base-item">
          <div class="teacher-name">{{ teacherData.name }}</div>
          <div class="teacher-title">
            {{ teacherData.job_title }} · {{ teacherData.college_name }}
          </div>
        </div>
      </div>
      <div class="introduction" v-html="teacherData.introduc"></div>
    </div>
  </el-dialog>
</template>
<script>
import { ElDialog } from "element-plus";
export default {
  props: {
    visible: Boolean,
    teacherData: Object,
    handleClose: Function,
  },
  components: {
    "el-dialog": ElDialog,
  }
};
</script>
<style lang="scss" scoped>
.teacher-detail {
  .teacher-base {
    display: flex;
    .img-wrapper {
      flex: 0 0 120px;
      height: 160px;
      position: relative;
      top: -86px;
      margin-right: 16px;
      img {
        object-fit: cover;
        height: 100%;
        width: 100%;
      }
    }
    .teacher-base-item {
      .teacher-name {
        font-size: 24px;
        line-height: 33px;
        color: #333;
        margin-bottom: 10px;
      }
      .teacher-title {
        font-size: 14px;
        line-height: 20px;
        color: #999;
      }
    }
  }
  .introduction {
    max-height: 190px;
    overflow-y: auto;
    margin-top: -56px;
  }
}
</style>
<style lang="scss">
.teacher-dialog {
  .el-dialog__body {
    padding: 12px 24px 24px;
  }
}
</style>